export const BY_NAVIGATION = "BY_NAVIGATION";
export const FROM_FLOW = "FROM_FLOW";
export const STREAM_TERMINATED = "STREAM_TERMINATED";
export const OVERLAY_CLICK_OR_ESCAPE_PRESS = "OVERLAY_CLICK_OR_ESCAPE_PRESS";
export const USER_ACTION = "USER_ACTION";
